export const SIMPLE_SIGN_ID = 1;
export const HELLO_SIGN_ID = 2;



// WEBPACK FOOTER //
// ./src/constants/productTiers.js